var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.fileList),function(file){return [_c('ys-file-list',{key:file.id,attrs:{"fileList":[file],"width":70,"height":70,"gutter":1}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }